import { type SetTenantDefaultCarrierMutation } from "~/gql/mutations/carrier.generated";
import { type GetCarriersQuery } from "~/gql/queries/carriers.generated";

const addSavedDefaultCarrier = (
	payload: SetTenantDefaultCarrierMutation["setTenantDefaultCarrier"],
	draft: GetCarriersQuery
): void => {
	const saved = payload.tenantCarrierConfig;
	const nodes = draft.carriers?.nodes;
	if (!saved?.carrier || !nodes || nodes.some((node) => node.carrier === saved.carrier)) return;
	nodes.push({ carrier: saved.carrier, tenantId: saved.tenantId });
};

export default addSavedDefaultCarrier;
